// Preview + commit mutations for the layout-import wizard. Kept separate
// from the modal so the modal stays presentational.

import { useMutation } from "@tanstack/react-query";

import { layoutImport } from "../../api/endpoints/layoutImport";
import type { CommitResponse, PreviewResponse } from "../../api/types/layoutImport";

export function useLayoutImport(
  accountSlug: string,
  tenantSlug: string,
  siteSlug: string,
) {
  const preview = useMutation<PreviewResponse, unknown, File>({
    mutationFn: (file) =>
      layoutImport
        .preview(accountSlug, tenantSlug, siteSlug, file)
        .then((r) => r.data),
  });

  const commit = useMutation<
    CommitResponse,
    unknown,
    { file: File; parseToken: string; applyUpdates?: boolean }
  >({
    mutationFn: ({ file, parseToken, applyUpdates }) =>
      layoutImport
        .commit(accountSlug, tenantSlug, siteSlug, file, parseToken, applyUpdates)
        .then((r) => r.data),
  });

  return { preview, commit };
}
